import { termosStep } from '../../shared/termosSections';
import { identificacaoSociedadeSection, enderecoSociedadeStep, DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE } from '../../shared/sociedadeSections';

const pedidoContratoAssociadoConfig = {
  id: 'pedido_contrato_associado',
  nome: 'Pedido de Contrato de Associado',
  descricao: 'Solicitação de registro de contrato de associado',
  icon: 'FaFileContract',
  categoria: 'sociedades',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento preenchido e assinado digitalmente', required: true },
      { id: 'contratoAssociado', tipoDocumentoProcesso: 539, name: 'Contrato de Associado', description: 'Contrato de associado assinado digitalmente pelo(s) sócio(s), associado e duas testemunhas', required: true }
    ]
  },

  paymentConfig: {
    amount: 102.00
  },

  protocoloConfig: {
    modeloRequerimento: '270',
    tiposAssunto: '678',
    tipoPedido: '239'
  },

  dadosRequerimentoConfig: DADOS_REQUERIMENTO_ENDERECO_SOCIEDADE,

  tituloConfig: {
    tipoLancamentoId: 140,
    enderecoOrigem: 'sociedadeSimples'
  },

  steps: [
    {
      id: 'dados_sociedade',
      title: 'Dados da Sociedade',
      sections: [
        identificacaoSociedadeSection()
      ]
    },
    enderecoSociedadeStep({ autoCep: true }),
    termosStep()
  ]
};

export default pedidoContratoAssociadoConfig;
